import { render, staticRenderFns } from "./audioclaim.vue?vue&type=template&id=7cd3fff8&scoped=true&"
import script from "./audioclaim.vue?vue&type=script&lang=js&"
export * from "./audioclaim.vue?vue&type=script&lang=js&"
import style0 from "./audioclaim.vue?vue&type=style&index=0&id=7cd3fff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd3fff8",
  null
  
)

export default component.exports